module.exports = __webpack_public_path__ + "img/bilo.7086c49d.png";